import { render, staticRenderFns } from "./Editqualificationdocument.vue?vue&type=template&id=0ae05bbc&scoped=true&"
import script from "./Editqualificationdocument.vue?vue&type=script&lang=js&"
export * from "./Editqualificationdocument.vue?vue&type=script&lang=js&"
import style0 from "./Editqualificationdocument.vue?vue&type=style&index=0&id=0ae05bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae05bbc",
  null
  
)

export default component.exports